const addAtribute = (htmlContent: string) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  const links = tempDiv.querySelectorAll('a');

  links.forEach(link => {
    if (!link.classList.contains('govuk-link')) {
      link.classList.add('govuk-link');
    }
  });

  return tempDiv.innerHTML;
};

const getPatientACPTagColorAndText = (
  text: string
): { color: string; displayText: string } => {
  let color: string;
  let displayText: string;

  if (text === null || text === undefined) {
    color = '';
    displayText = '';
  } else {
    switch (text.toLowerCase()) {
      case 'completed':
        color = 'green';
        displayText = 'Completed';
        break;
      case 'inprogress':
        color = 'orange';
        displayText = 'In progress';
        break;
      case 'not started':
        color = 'red';
        displayText = 'Not started';
        break;
      default:
        color = '';
        displayText = text.charAt(0).toUpperCase() + text.slice(1);
        break;
    }
  }

  return { color, displayText };
};

export { addAtribute, getPatientACPTagColorAndText };
